import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../app-authenticator/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    private authenticationService: AuthenticationService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    if (request.url.includes('app.config.json')) {
      return next.handle(request);
    }

    const token = this.getAccessToken();
    let contentType = 'application/json'

    let headers = new HttpHeaders();
    if (request.url.includes("import/preview") || request.url.includes("import/partial")) {
      contentType = 'multipart/form-data'
      headers = new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
    } else {
      headers = new HttpHeaders({
        'Content-Type': contentType,
        Accept: 'application/json, application/octet-stream',
        Authorization: 'Bearer ' + token,
      });
    }

    request = request.clone({
      headers
    });

    return next.handle(request);
  }

  private getAccessToken(): string {
    const sessionToken = sessionStorage.getItem('access_token');
    if (sessionToken && sessionToken !== 'undefined' && sessionToken !== 'null') {
      return sessionToken;
    }
    return this.authenticationService.getToken() || '';
  }
}
